<div  class="flex flex-col gap-4">
  <form nz-form [formGroup]="searchForm" class="ant-advanced-search-form">
    <div class="flex items-center gap-4">
      <div>
        <nz-range-picker
          [nzRanges]="ranges"
          [(ngModel)]="date"
          [ngModelOptions]="{ standalone: true }"
          [nzFormat]="dateFormat"
          [nzPlaceHolder]="[
            'statistic.operation.search.start' | translate,
            'statistic.operation.search.finish' | translate
          ]"
          (ngModelChange)="changeCalendar($event)"
        ></nz-range-picker>
      </div>
      <div >
        <beautyapp-input
          placeholder="{{
            'statistic.operation.search.operationNumber' | translate
          }}"
          formControlName="operationId"
        ></beautyapp-input>
      </div>
      <div >
        <beautyapp-select
          placeholder="{{
            'statistic.operation.search.sourceOperation' | translate
          }}"
          formControlName="operationSource"
          [data]="operationSource"
          valueMember="id"
          displayMember="name"
        ></beautyapp-select>
      </div>
      <div >
        <beautyapp-select
          formControlName="employeeId"
          [data]="employees() || []"
          placeholder="{{ 'statistic.operation.search.employee' | translate }}"
          valueMember="id"
          displayMember="fullName"
        ></beautyapp-select>
      </div>

      <div class="flex gap-4">
        <button nz-button nzType="primary" (click)="search()">
          {{ 'buttons.search' | translate }}
        </button>
        <button nz-button (click)="clearSearch()">
          {{ 'buttons.clear' | translate }}
        </button>
      </div>
    </div>
  </form>
  <nz-table
    nzShowSizeChanger
    [nzData]="loadData()"
    [nzFrontPagination]="false"
    [nzLoading]="loader()"
    [nzTotal]="total()"
    [nzPageSize]="pageSize()"
    [nzPageIndex]="page()"
    [nzVirtualForTrackBy]="trackByIndex"
    (nzQueryParams)="paginatorChange($event)"
    [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
    nzTableLayout="auto"
    [nzScroll]="{ x: '84vw' }"
    nzSize="small"
    >
    <thead>
      <tr>
        <th nzWidth="80px">
          {{ 'statistic.operation.column.operationNumber' | translate }}
        </th>
        <th nzWidth="180px">
          {{ 'statistic.operation.column.sourceOperation' | translate }}
        </th>
        <th nzWidth="200px">
          {{ 'statistic.operation.column.paymentMethod' | translate }}
        </th>
        <th nzWidth="100px">
          {{ 'statistic.operation.column.date' | translate }}
        </th>
        <th nzWidth="110px">
          {{ 'statistic.operation.column.price' | translate }}
        </th>
        <th nzWidth="80px">
          {{ 'statistic.operation.column.cash' | translate }}
        </th>
        <th nzWidth="80px">
          {{ 'statistic.operation.column.card' | translate }}
        </th>
        <th nzWidth="100px">
          {{ 'statistic.operation.column.balance' | translate }}
        </th>
        <th nzWidth="220px">
          {{ 'statistic.operation.column.user' | translate }}
        </th>
        <th nzWidth="220px">
          {{ 'statistic.operation.column.employee' | translate }}
        </th>
        <th nzWidth="200px">
          {{ 'statistic.operation.column.createdBy' | translate }}
        </th>
        <th nzWidth="250px">
          {{ 'statistic.operation.column.procedure' | translate }}
        </th>
        <th nzWidth="150px">
          {{ 'statistic.operation.column.created' | translate }}
        </th>
        <th nzWidth="80px" nzRight></th>
      </tr>
    </thead>
    <tbody>
      @for (row of loadData(); track row.id) {
        <tr>
          <td>{{ row?.id }}</td>
          <td>
            {{ 'OPERATION_SOURCE.' + row?.operationSource | translate }}
            @if (row?.isGift) {
              <i nz-icon nzType="gift" nzTheme="outline"></i>
            }
            @if (row?.description) {
              <i
                nz-icon
                nzType="comment"
                nzTheme="outline"
                [nz-tooltip]="row?.description"
              ></i>
            }
          </td>
          <td>
            {{ row?.paymentType | paymentType | translate }}
          </td>
          <td>{{ row?.operationDate | date: 'dd/MM/yyyy' }}</td>
          <td>{{ +row?.priceLastSum | number: '1.2-2' }}</td>
          <td>{{ +row?.cash | number: '1.2-2' }}</td>
          <td>{{ +row.card | number: '1.2-2' }}</td>
          <td>{{ +row.balance | number: '1.2-2' }}</td>
          <td>{{ row?.user ? row.user.fullName : '' }}</td>
          <td>{{ row?.employee ? row?.employee?.user?.fullName : '' }}</td>
          <td>{{ row?.createdBy?.username }}</td>
          <td>
            <nz-tag>{{ getDetail(row) }}</nz-tag>
            @if (
              row.booking &&  row.booking.services.length && row.booking.services.length > 1
              ) {
              <nz-tag
                >
                +{{ row.booking.services.length - 1 }}</nz-tag
                >
              }
            </td>
            <td>{{ row?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td nzRight>
              <nz-space>
                <button
                  *nzSpaceItem
                  (click)="view(row)"
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  nzShape="circle"
                  >
                  <i nz-icon nzType="eye"></i>
                </button>
              </nz-space>
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr style="font-weight: bold; background: #fafafa;">
          <td colspan="4" style="text-align: right;">ჯამი:</td>
          <td>{{ totals().totalPrice | number:'1.0-2' }}</td>
          <td>{{ totals().totalCash | number:'1.0-2' }}</td>
          <td>{{ totals().totalCard | number:'1.0-2' }}</td>
          <td>{{ totals().totalBalance | number:'1.0-2' }}</td>
          <td colspan="6"></td>
        </tr>
      </tfoot>
    </nz-table>
  </div>
